export const COOKIE_NAME = 'CookieAgreement';

export const COOKIE_VALUE = 'drsa';
